import { render, staticRenderFns } from "./Fidz.vue?vue&type=template&id=4478e4c6&"
import script from "./Fidz.vue?vue&type=script&lang=ts&"
export * from "./Fidz.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports